// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { AttributeTypeModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Tooltip from "@store/MobiusOverrides/Tooltip/Tooltip";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
}

export interface productIconsStyles {
    iconsWrapper?: InjectableCss;
}

export const productIconsStyles: productIconsStyles = {
    iconsWrapper: {
        css: css`
            margin: 0.5em 0;
            width: 100%;

            .product-icons-list {
                padding: 0.25em 0.25em 0.5em;
                border-top: 0.0625rem solid ${getColor("common.border")};
                border-bottom: 0.0625rem solid ${getColor("common.border")};
            }
            .product-icons-list > div {
                margin: 0;
            }
            .product-icons-list .product-icon {
                display: inline-block;
                width: 1.5em;
                height: 1.5em;
                transform: translateY(0.2em);
            }
            .product-icons-list .product-icon:hover {
                opacity: 0.8;
            }
            .product-icons-list .product-icon.certificaterequiredicon {
                background-image: url("/staticContent/icons/certificate.svg");
            }
            .product-icons-list .product-icon.cytotoxicicon {
                background-image: url("/staticContent/icons/cytotoxic.svg");
            }
            .product-icons-list .product-icon.frozenicon {
                background-image: url("/staticContent/icons/frozen.svg");
            }
            .product-icons-list .product-icon.hazardousicon {
                background-image: url("/staticContent/icons/hazardous.svg");
            }
            .product-icons-list .product-icon.humanicon {
                background-image: url("/staticContent/icons/human.svg");
            }
            .product-icons-list .product-icon.nonreturnableicon {
                background-image: url("/staticContent/icons/non-returnable.svg");
            }
            .product-icons-list .product-icon.refrigeratedicon {
                background-image: url("/staticContent/icons/refrigerated.svg");
            }
            .product-icons-list .product-icon.schedule2icon {
                background-image: url("/staticContent/icons/schedule2.svg");
            }
            .product-icons-list .product-icon.schedule3icon {
                background-image: url("/staticContent/icons/schedule3.svg");
            }
            .product-icons-list .product-icon.veterinaryicon {
                background-image: url("/staticContent/icons/veterinary.svg");
            }
            .product-icons-list > div + div {
                margin-top: 0;
                margin-left: 0.5em;
            }
            .product-icons-list .product-icon .icon {
                display: block;
                height: 100%;
                border-bottom: 0;
            }
            .product-icons-list .product-preference-flag {
                display: inline-block;
                width: 1.5em;
                height: 1.5em;
                border-radius: 100%;
            }
            .product-icons-list .product-preference-flag.red {
                background-color: ${getColor("productPreferences.red")};
            }
            .product-icons-list .product-preference-flag.amber {
                background-color: ${getColor("productPreferences.amber")};
            }
            .product-icons-list .product-preference-flag.green {
                background-color: ${getColor("productPreferences.green")};
            }
        `,
    },
};

const styles = productIconsStyles;

type Props = OwnProps;

const ProductIcons = ({ product }: Props) => {
    const preferenceText = product?.properties?.productPeferenceText;
    const preferenceColor = product?.properties?.productPeferenceColor;

    const endsWithIcon = (name?: string) => typeof name === "string" && name.endsWith("Icon");

    const iconsFromAttributeTypes: AttributeTypeModel[] =
        product.attributeTypes?.filter(at => endsWithIcon(at?.name)) ?? [];

    const rawIcons = (product as any)?.properties?.icons as any;
    let iconsFromProperties: AttributeTypeModel[] = [];
    if (Array.isArray(rawIcons)) {
        iconsFromProperties = rawIcons.filter(i => endsWithIcon(i?.name));
    } else if (typeof rawIcons === "string" && rawIcons.trim()) {
        try {
            const parsed = JSON.parse(rawIcons);
            if (Array.isArray(parsed)) {
                iconsFromProperties = parsed.filter((i: any) => endsWithIcon(i?.name));
            }
        } catch {
            // ignore malformed JSON
        }
    }

    const productIcons = [...iconsFromAttributeTypes, ...iconsFromProperties];

    if (productIcons.length === 0 && !preferenceText) {
        return null;
    }
    return (
        <StyledWrapper {...styles.iconsWrapper}>
            <section className="product-icons-list">
                {preferenceText && (
                    <Tooltip
                        text={preferenceText}
                        displayOnHover={true}
                        triggerComponent={
                            <div className={`product-icon`}>
                                <span
                                    tabIndex={0}
                                    id={"product-preference"}
                                    className={`product-preference-flag ${preferenceColor?.toLowerCase()}`}
                                />
                            </div>
                        }
                    />
                )}
                {productIcons.map((icon, index) => {
                    const nameLower = icon.name.toLowerCase();

                    return (
                        <Tooltip
                            key={`${nameLower}-${index}`}
                            text={icon.label}
                            displayOnHover={true}
                            triggerComponent={
                                <div className={`product-icon ${nameLower}`}>
                                    <span id={nameLower} className="icon" />
                                </div>
                            }
                        />
                    );
                })}
            </section>
        </StyledWrapper>
    );
};

export default ProductIcons;
